<template>
   <blank-layout>
      <v-row>
         <v-col cols="12" lg="7" xl="6" class="info d-none d-md-flex align-center justify-center">
            <v-container>
            <div class="pa-10">
               <v-row justify="center">
                  <v-col cols="8" xl="5">
                  <div>
                     <div class="text-center">
                        <v-avatar color="white" width="150" height="150">
                           <img src="@/assets/images/miplogo-300x300.png">
                        </v-avatar>
                     </div>
                     <br>
                     <h2 class="display-1 white--text font-weight-medium">
                        MIP Online Membership System
                     </h2>
                     <!-- <h6 class="subtitle-1 mt-4 white--text op-5 font-weight-regular">
                        Some introduction description about the system. Build using Laravel 8 JetStream with AdminPro Template. Vue.JS front-end with Laravel 8 back-end.
                     </h6>
                     <v-btn class="mt-4 text-capitalize" x-large outlined color="white">Learn More</v-btn> -->
                  </div>
                  </v-col>
               </v-row>
            </div>
            </v-container>
         </v-col>
         <v-col cols="12" lg="5" xl="6" class="d-flex align-center">
            <v-container>
            <div class="pa-7 pa-sm-12">
               <v-row>
                  <v-col cols="12" lg="9" xl="6">
                  <!-- <img src="@/assets/images/logo-icon.png" /> -->
                  <h2 class="font-weight-bold blue-grey--text text--darken-2">Sign in</h2>
                  <h6 class="subtitle-1">
                     Don't have an account?
                     <a href="member-register" class>Sign Up</a>
                  </h6>

                  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="submit">
                     <v-text-field
                        v-model="memberid"
                        :rules="memberidRules"
                        label="Malaysia IC No."
                        class="mt-4"
                        required
                        outlined
                     ></v-text-field>
                     <v-text-field
                        v-model="password"
                        :counter="15"
                        :rules="passwordRules"
                        label="Password"
                        required
                        outlined
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="show1 ? 'text' : 'password'"
                        @click:append="show1 = !show1"
                     ></v-text-field>

                     <div class="d-block d-sm-flex align-center mb-4 mb-sm-0">
                        <v-checkbox
                           v-model="rememberme"
                           label="Remember me?"
                           required
                        ></v-checkbox>
                        <div class="ml-auto">
                        <a href="/forgot-password" class="link">Forgot pwd?</a>
                        </div>
                     </div>
                     <v-btn
                        :disabled="!valid||submitting"
                        color="info"
                        block
                        class="mr-4"
                        submit
                        
                        @click="submit"
                     >Sign In</v-btn>
                  </v-form>
                  <v-snackbar v-model="showerror" timeout="5000" color="red" dark centered>
                     {{ errormsg }}
                     <template v-slot:action="{ attrs }">
                     <v-btn color="blue" text v-bind="attrs" @click="showerror = false">
                        Close
                     </v-btn>
                     </template>
                  </v-snackbar>
                  <!-- <div class="text-center mt-6">
                     <v-chip pill class="mr-2">
                        <v-avatar left>
                        <v-btn color="blue lighten-1" class="white--text">
                           <v-icon>mdi-twitter</v-icon>
                        </v-btn>
                        </v-avatar>Twitter
                     </v-chip>
                     <v-chip pill>
                        <v-avatar left>
                        <v-btn color="teal lighten-2" class="white--text">
                           <v-icon>mdi-github</v-icon>
                        </v-btn>
                        </v-avatar>Github
                     </v-chip>
                  </div> -->
                  </v-col>
               </v-row>
            </div>
            </v-container>
         </v-col>
      </v-row>
   </blank-layout>
</template>

<script>
import BlankLayout from '@/Layouts/BlankLayout.vue';

export default {
   components: { BlankLayout },
   name: "MOMLogin",
   props: {
      errors: Object,
   },

   data() {
      return {
         showerror: false,
         errormsg: '',
         submitting: false,
         valid: true,
         password: "",
         show1: false,
         passwordRules: [
            v => !!v || "Password is required",
            v => (v && v.length >= 8) || "Password must be at least 8 characters"
         ],
         memberidRules: [
            v => !!v || "Malaysia IC Number is required",
         ],
         memberid: '',
         rememberme: false
      }
   },

   methods: {
      submit() {
         const data = {
            identity: this.memberid,
            password: this.password,
            remember: this.rememberme,
            login_type: 'member',
         }

         this.$refs.form.validate();
         if (this.$refs.form.validate(true)) {
            this.$inertia.post(this.route('login'), data, {
               onStart: () => this.submitting = true,
               onSuccess: () => {
                  window.location.replace('/dashboard')
               },
               onFinish: () => {
                  this.submitting = false
                  const errorKeys = Object.keys(this.errors)
                  if (errorKeys.length > 0) {
                     this.errormsg = this.errors[errorKeys[0]]
                     this.showerror = true
                  }
               }
            })
         }
      }
   },

   mounted: function() {
      if (this.$page.user) {
         window.location.replace('/dashboard')
      }
   }
};
</script>

<style scoped>
</style>
